import { WorkType } from 'src/graphql/generated';
import { CajaWorkType } from 'src/types/cajaWorkType';

export const mapUIWorkTypeToHirer = (
  workType: CajaWorkType,
): WorkType | undefined => {
  switch (workType) {
    case CajaWorkType.FullTime:
      return WorkType.FULLTIME;
    case CajaWorkType.PartTime:
      return WorkType.PARTTIME;
    case CajaWorkType.Contract:
      return WorkType.CONTRACT_TEMP;
    case CajaWorkType.Casual:
      return WorkType.CASUAL;
  }
};
